import React from 'react';

import { ShotCharactersSelector } from '../../schedule/components/shot-characters-selector';
import { Bloc, BlocContent } from '../../../routes/project/components/step-drawer';

import type { Shot } from '../../../app/entities';
import { TagLabel } from '../../tags/components/styled-tags-components';
import { TagsContainer } from '../../tags/components/tags-viewer';

interface CharactersSelectProps {
  key: string;
  shot: Shot;
  isShotsBulkUpdate?: boolean;
  handleShotsBulkUpdate?: ({
    characterIdToRemove,
    characterIdToAdd,
  }: {
    characterIdToRemove?: string;
    characterIdToAdd?: string;
  }) => void;
}

export const CharactersSelect: React.FC<CharactersSelectProps> = ({
  shot,
  handleShotsBulkUpdate,
  isShotsBulkUpdate = false,
}) => {
  const handleRemoveCharacter = (characterIdToRemove: string) => {
    isShotsBulkUpdate
      ? handleShotsBulkUpdate!({ characterIdToRemove })
      : shot.deleteCharacter(characterIdToRemove);
  };

  const handleAddCharacter = (characterIdToAdd: string) => {
    isShotsBulkUpdate
      ? handleShotsBulkUpdate!({ characterIdToAdd })
      : shot.addCharacter(characterIdToAdd);
  };

  return (
    <ShotCharactersSelector
      shot={shot}
      onAdd={handleAddCharacter}
      onRemove={handleRemoveCharacter}
      trigger={() => (
        <Bloc onClick={(e: React.MouseEvent) => e.stopPropagation()}>
          <label>Characters</label>

          <BlocContent>
            <TagsContainer data-wrap={true}>
              {shot.characters.map((character) => (
                <TagLabel>
                  <span>{character.name}</span>
                </TagLabel>
              ))}
            </TagsContainer>
          </BlocContent>
        </Bloc>
      )}
    />
  );
};
